<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="profile_page_wrap profile_pages">
            <div class="container">
                <h1>Profile</h1>
                <div class="row">
                    <div class="col-md-3">
                        <UserSidebarMenu></UserSidebarMenu>
                    </div>
                    <div class="col-md-9">
                        <div class="right_content">
                            <div v-if="show_success_message" class="alert alert-success alert-dismissible fade show" role="alert">
                                <strong>{{ success_message }}</strong>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <form v-on:submit.prevent="edit_profile">  
                                <div class="row">
                                    <div class="col-md-6 form_field_block">
                                        <label>Name</label>
                                        <input type="text" v-model="name" name="name" value="" placeholder="Name" class="form-control" v-bind:class="{required : isInputValid(errors.name)}">
                                        <span v-if="errors.name">{{ getError(errors.name) }}</span>
                                    </div>
                                    <div class="col-md-6 form_field_block">
                                        <label>Email</label>
                                        <input type="email" v-model="email" name="email"  placeholder="Email" class="form-control" v-bind:class="{required : isInputValid(errors.email)}">
                                        <span v-if="errors.email">{{ getError(errors.email) }}</span>
                                    </div>
                                    <div class="col-md-12 form_field_block">
                                        <label>Address</label>                        
                                        <textarea v-model="address" id="address-input" name="address" placeholder="Address" class="form-control"v-bind:class="{required : isInputValid(errors.address)}"></textarea>
                                        <span v-if="errors.address">{{ getError(errors.address) }}</span>
                                    </div>
                                    <div class="col-md-6 form_field_block">
                                        <label>Contact Number</label>
                                        <input type="text"  v-model="contact_number" name="phone" value="" placeholder="Contact Number" class="form-control"  v-bind:class="{required : isInputValid(errors.contact_number)}">
                                        <span v-if="errors.contact_number">{{ getError(errors.contact_number) }}</span>
                                    </div>
                                    <div class="col-md-6 form_field_block">
                                        <label>SCFHS No</label>
                                        <input type="text" v-model="scfhs_number" id="scfhs_number-input" name="scfhs_number" placeholder="SCFHS No"  v-bind:class="{required : isInputValid(errors.scfhs_number)}" class="form-control" >
                                        <span v-if="errors.scfhs_number">{{ getError(errors.scfhs_number) }}</span>
                                    </div>
                                    <div class="col-md-6 form_field_block">
                                        <label>Workplace</label>
                                        <input type="text" v-model="workplace"  id="workplace-input" name="workplace" placeholder="Workplace*" class="form-control"  v-bind:class="{required : isInputValid(errors.workplace)}">
                                        <span v-if="errors.workplace">{{ getError(errors.workplace) }}</span>
                                    </div>
                                    <div class="col-md-6 form_field_block">
                                        <label>Profession</label>
                                        <select v-model="profession" name="profession" id="profession-input" class="form-control"   v-bind:class="{required : isInputValid(errors.profession)}">
                                            <option value="">Profession</option>
                                            <option v-for="option in profession_list" :key="option.name" :value="option.name">{{ option.name }}</option>
                                        </select>
                                        <span v-if="errors.profession">{{ getError(errors.profession) }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="submit" name="Save Changes" value="Save Changes" class="btn primary-btn read_more">
                                    </div>
                                </div>
                            </form>
                        </div>
                        <table class="table" v-if="user != null" style="display: none;">
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>{{user.name}}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>{{user.email}}</td>
                                </tr>
                                <tr>
                                    <td>Contact Number</td>
                                    <td>{{user.contact_number}}</td>
                                </tr>
                                <tr>
                                    <td>Workplace</td>
                                    <td>{{user.workplace}}</td>
                                </tr>
                                <tr>
                                    <td>Profession</td>
                                    <td>{{user.profession}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import HeaderMenu from './../HeaderMenu'
import UserSidebarMenu from './UserSidebarMenu'
export default{
    name: 'Profile',
    components:{
        'HeaderMenu'     : HeaderMenu,
        'UserSidebarMenu': UserSidebarMenu
    },
    data() {
        this.getUser().then(res => {
            if(res != null ){
                this.user = res;
                this.name = res.name;   
                this.email = res.email;   
                this.address = res.address;   
                this.contact_number = res.contact_number;   
                this.scfhs_number = res.scfhs_number;   
                this.workplace = res.workplace;   
                this.profession = res.profession;   
            }
            else{
                this.$router.push({name:'Login'})
            }
        })

        return {
            user:null,
            current_locale:this.$i18n_global.locale,
            show_success_message:false,
            success_message:'Profile has been updated successfully',
            errors:[],
            name: '',
            email: '',
            address:'',
            contact_number:'',
            scfhs_number:'',
            workplace:'',
            profession:'',
            profession_list:[
                { name:'Doctor' },
                { name:'Dentist' },
                { name:'Pharmacist' },
                { name:'Nurse' },
                { name:'Medical Science Specialist' },
                { name:'Technician' }
            ]
        }
    },
    methods: {
        async getUser() {
            return this.$store.state.auth.current_user;
        },
        edit_profile() {
            var _self = this;
            _self.$axios_global.post(this.$hostname+'/api/edit-profile',{
                    id: _self.user.id,
                    name: _self.name,
                    email: _self.email,
                    address:_self.address,
                    contact_number:_self.contact_number,
                    scfhs_number:_self.scfhs_number,
                    workplace:_self.workplace,
                    profession:_self.profession
                })
                .then((res) => {
                    console.log("success",res);
                    _self.$store.commit('set_user_token',res.data.token);
                    _self.$store.commit('set_user',res.data.user);
                    _self.show_success_message = true;
                    setTimeout(function(){
                        _self.show_success_message = false;
                    },4000);
                })
                .catch((error) => {
                    console.log("error while editing profile",error);
                    this.errors = error.response.data;
                    return false;
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Profile.vue